import { Subject } from 'rxjs';
import { IDialogOptions } from './dialog.service';

export class DialogBase {
  extraData?: any;
  dialogOptions: IDialogOptions;

  onClose: Subject<IDialogOnClose> = new Subject<IDialogOnClose>();

  /**
   * this function is used to run some initialization code after the dialog instantiate and before it is shown
   */
  initDialog() {;}

  close(reason: IDialogOnClose) {
    this.onClose.next(reason);
  }

  cancel() {
    this.close({reason: DialogCloseReason.CANCEL, data: null});
  }
}

export interface IDialogOnClose<R = DialogCloseReason, D = any> { reason?: R; data?: D; };

export enum DialogCloseReason {
  OK,
  CANCEL,
  ABORTED
};
